export class Device {
  deviceId: number;
  name: string;
  address: number;
  devicetype: number;
  description: string;
  isTablet: boolean;
}
